import { useQuery } from "@tanstack/react-query"
import { getWhatsappAccountReadinessAction } from "@/server-actions/whatsapp-templates"

export function useWhatsappAccountReadiness(channelId: string) {
  return useQuery({
    queryKey: ["whatsapp-account-readiness", channelId], enabled: Boolean(channelId), staleTime: 60_000,
    queryFn: async () => {
      const result = await getWhatsappAccountReadinessAction({ channel_id: channelId })
      if ("status" in result) throw new Error(result.errorMessage)
      return result.readiness
    },
  })
}
